import React from 'react';

import {injectIntl} from 'react-intl';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import {fetchUserOrders} from '../../ducks/user';

import {isReviewWindowOpen} from '../../ducks/reviews';

import Loader from '../../components/loader/Loader';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import Order from '../../components/order/Order';
import Button from '../../components/button/Button';
import ChannelLink from '../channelUtils/ChannelLink';
import CategoryMenuProfile from '../../components/categoryMenu/CategoryMenuProfile';
import LoadMore from '../../components/loadMore/LoadMore';

@injectIntl
@connect(({user}) => ({orders: user.orders}))
export default class ProfileOrders extends React.PureComponent {
  static fetchData = ({dispatch, orders}) => orders === undefined && dispatch(fetchUserOrders());

  componentDidMount() {
    ProfileOrders.fetchData(this.props);
  }

  componentDidUpdate() {
    ProfileOrders.fetchData(this.props);
  }

  loadMore = () => {
    const {dispatch, orders} = this.props;
    dispatch(fetchUserOrders(orders.page + 1));
  };

  // True once every distinct product in the order has a review — at which
  // point the "Leave a review" CTA is no longer relevant.
  isFullyReviewed = (order) => {
    const codes = order.items
      .map(item => item.variant && item.variant.product && item.variant.product.code)
      .filter(Boolean);
    const reviewed = (order.productReviews || []).map(review => review.productCode);

    return codes.length > 0 && codes.every(code => reviewed.indexOf(code) !== -1);
  };

  renderReviewFooter = (order) => {
    const {intl} = this.props;
    const to = `/order/${order.tokenValue}/review`;
    const label = intl.formatMessage({id: 'section.generic.leave-review'});

    return (
      <React.Fragment>
        {/* Prompt copy hidden for now; the CTA speaks for itself.
        <span className="order__footer-message">
          {intl.formatMessage({id: 'section.profile.review-prompt'})}
        </span>
        */}

        <div className="order__footer-actions">
          <Button component={ChannelLink} to={to}>{label}</Button>
        </div>
      </React.Fragment>
    );
  };

  renderOrders = ({orders}) => (
    <div>
      {orders.map(order => (
        <Order
          key={order.id}
          order={order}
          footer={order.state === 'fulfilled' && order.tokenValue && isReviewWindowOpen(order) && !this.isFullyReviewed(order) && this.renderReviewFooter(order)}
        />
      ))}
    </div>
  );

  render() {
    const {intl, orders} = this.props;

    if (!orders) {
      return <Loader page/>;
    }

    return (
      <div className="page-profile">
        <Helmet>
          <title>{intl.formatMessage({id: 'section.profile.orders'})}</title>
        </Helmet>

        <Breadcrumbs links={[
          {name: intl.formatMessage({id: 'section.profile.title'}), to: '/profile'},
          {name: intl.formatMessage({id: 'section.profile.orders'})}
        ]}/>

        <CategoryMenuProfile title={intl.formatMessage({id: 'section.profile.user-profile'})}/>

        <h1>{intl.formatMessage({id: 'section.profile.orders'})}</h1>

        <LoadMore
          {...orders}
          itemsProp="orders"
          component={this.renderOrders}
          onLoadMore={this.loadMore}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/profilePage/ProfileOrders.js